import module from './module.js'
/* Components */
import './components/component.js'

export default module.name



// WEBPACK FOOTER //
// ./src/inicio/index.js